<template>
  <sweet-modal ref="modal" overlay-theme="dark">
    <img
      :src="imgUrl"
      alt=""
      v-if="imgUrl"
      class="img-fluid"/>
  </sweet-modal>
</template>

<script>
export default {
  data () {
    return {
      imgUrl: null
    }
  },
  methods: {
    open (url) {
      this.imgUrl = url
      this.$refs.modal.open()
    }
  }
}
</script>
